import React from 'react';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import Icon from '../icon/Icon';

export default function HeaderBurger() {
  return (
    <label htmlFor={'menu-burger'} className={'header__burger custom-header__burger'}>
      <p />
      <p />
      <p />
    </label>
  );
}
